
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
// 数据看板客户查看关键指标接口
export function getCustomerKeyDataBoard(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/customer/dashboard', data)
}
// 数据看板客户阶段接口
export function getCustomerStageDataBoard(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/customer/statusList', data)
}
// 数据看板成交客户分布情况
export function getTransactCusDistribution(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/customer/levelOrGradeList', data)
}
// 数据看板异动类型分布情况
export function getAlarmTypeDistribution(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/alarm/typeList', data)
}
// 数据看板异动等级分布情况
export function getAlarmLevelDistribution(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/alarm/levelList', data)
}
// 数据看板跟进及时率
export function getFollowUpRate(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/customer/followingUpRateList', data)
}
// 数据看板客户汇总
export function getCustomerGathering(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/customer/incList', data)
}
// 数据看板异动趋势
export function getAlarmTrend(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/alarm/trend', data)
}
// 数据看板异动反馈情况
export function getAlarmFeedback(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/alarm/feedbackList', data)
}
// 每月业绩目标完成情况
export function getMonthlyTargetCompletion(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/revenue/targetCompletionList', data)
}
// 新激活客户数
export function getNewActivatedCustomerCount(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/customer/activationList', data)
}
// 每月新激活客户月销售额
export function getNewActivatedCustomerMonthlyRevenue(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/revenue/salesAmountList', data)
}
// 查询客户拜访情况
export function getVisitCustomerCompletion(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/customer/visit', data)
}
// 客户营收汇总
export function getCustomerRevenueDataBoard(data?: any) {
  return request.post<AxiosResult>('/fbu/api/report/revenue/dashboard', data)
}
